import { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { setPreConstructionPage } from 'src/redux/reducer/website.reducer';
import { getRequest } from 'src/services';
import { endpoints } from 'src/utils/axios';

const usePreConstructionSection = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();

  const getPreConstructionSectionJson = useCallback(async (page = 1) => {
    setLoading(true);
    setError(null);

    try {
      const response = await getRequest(`${endpoints.admin_dashboard.website?.pre_construction_page?.pre_construction_section}`);
      console.log("🚀 ~ getPreConstructionSectionJson ~ data:", response);
      console.log("🚀 ~ getPreConstructionSectionJson ~ data.data:", JSON.parse(response.web_page.json_data));

      const finalResponse = JSON.parse(response.web_page.json_data);

      if (finalResponse) {
        dispatch(setPreConstructionPage(finalResponse));
        setData(finalResponse);
      }

      return finalResponse;
    } catch (err) {
      console.error("Error fetching Pre Construction section data:", err);
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  }, [dispatch]);

  // Optional: Auto-fetch on mount
  const fetchOnMount = useCallback(() => {
    getPreConstructionSectionJson();
  }, [getPreConstructionSectionJson]);

  return {
    data,
    loading,
    error,
    getPreConstructionSectionJson,
    fetchOnMount,
    refetch: getPreConstructionSectionJson
  };
};

export default usePreConstructionSection;
